import styled from 'styled-components'

export const Root = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;

  @media print {
    display: none;
  }

  @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
    flex-direction: column;

    > a {
      padding-bottom: 20px;
    }

    .bookmark-print {
      display: flex;
      align-items: center;
    }
  }
`
